import classNames from "classnames";
import { useEffect, useState, useRef } from "react";
import { isEmailValid } from "@/utils/email";
import { useSearchParams } from "next/navigation";

export default function CardPaymentEmail({ email, updateEmail, message }) {
    const emailRef = useRef(email);
    const [innerError, setInnerError] = useState(false);
    const [innerEmail, setInnerEmail] = useState(email);
    const searchParams = useSearchParams();
    const autoFillEmail = searchParams.get("autoFillEmail");

    useEffect(() => {
        if (autoFillEmail === "true") {
            setInnerEmail(`test+${(Math.random() * 100).toFixed(4).replace(".", "")}@atly.com`);
            emailRef.current.focus();
            emailRef.current.select();
            emailRef.current.blur();
        }
    }, [autoFillEmail]);

    useEffect(() => {
        setInnerError(message);
    }, [message]);

    useEffect(() => {
        setInnerEmail(email);
    }, [email]);

    return (
        <div className="relative">
            <label htmlFor='email' className={classNames({
                'text-sky-950 text-xs': true,
            })}>Email</label>
            {innerError && <p className="absolute right-0 top-2 text-red-500 text-xs">REQUIRED</p>}
            <input
                type="email"
                ref={emailRef}
                value={innerEmail}
                placeholder='Email'
                onChange={(event) => {
                    setInnerEmail(event.target.value);
                }}
                onFocus={() => {
                    setInnerError(false);
                }}
                onBlur={(event) => {
                    const emailValue = event.target.value;
                    updateEmail(emailValue);
                    setInnerError(!emailValue || !isEmailValid(emailValue));
                }}
                className={classNames(`mb-3 flex
                    placeholder:text-[#5c7799]
                    justify-center items-center w-full border border-gray-[#e6e6e6] 
                    shadow-[0px_1px_1px_rgba(0,0,0,0.03),0px_3px_6px_rgba(0,0,0,0.02)] 
                    rounded-[5px] p-2 bg-white text-sky-950`, {
                    'border-red-500 text-red-500': innerError
                })} />
        </div>
    )
}